import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { AddInterpreterService } from './add-interpreter.service';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-add-interpreter',
  templateUrl: './add-interpreter.component.html',
  styleUrls: ['./add-interpreter.component.scss']
})
export class AddInterpreterComponent implements OnInit, OnDestroy {
  // @Input() parentFormGroup: FormGroup;
  // petitionTaskForm: FormGroup;
  interpreterDetailsForm: FormGroup;
  languagesList = [];
  interpreterName = [];
  isIncludeInterpreter: boolean = false;
  interpreterList = [];
  matchedInterpreterList = [];
  form;
  companyId: number;
  userId: number;
  selectedlanguage:string='';
  @Input() subTaskDetails: any  = null;
  destroy$ = new Subject<void>();
  constructor(
    private fb: FormBuilder,
    private apiService: AddInterpreterService,
    private parentFor: FormGroupDirective,
    private toast: ToastrService,
  ) { 
    this.companyId = parseInt(sessionStorage.getItem('companyId'));
    this.userId = parseInt(sessionStorage.getItem('userId'));
  }

  ngOnInit(): void {  
    this.getLanguages();
    this.interpreterDetailsForm = this.fb.group({
      isInterpreterReqd: new FormControl('No'),
      interpreterLangId: new FormControl(''),
      interpreterId: new FormControl(''),
      interpreterLanguageId: new FormControl(''),
    });

    this.form = this.parentFor.form;
    this.form.addControl('isInterpreterReqd', new FormControl('No'));
    this.form.addControl('interpreterLangId', new FormControl(''));
    this.form.addControl('interpreterId', new FormControl(''));
    this.form.addControl('interpreterLanguageId', new FormControl(''));

    if(this.subTaskDetails && this.subTaskDetails.isInterpreterReqd){
      const isChecked = this.subTaskDetails.isInterpreterReqd === 'YES' ? true : false;
      this.isIncludeInterpreter = isChecked;
      this.includeInterpreter({checked: isChecked});
      if(isChecked){
        const patchvalue = {
          isInterpreterReqd: 'Yes'
        };
        this.form.patchValue(patchvalue);
        this.interpreterDetailsForm.patchValue(patchvalue);
      }
    }
  }

  // loadfilteredInterpreterList() {
  //   this.apiService.filteredInterpreterList(this.companyId,this.userId).subscribe((response) => {
  //     this.interpreterList = response.map(ele=>{
  //       ele.name = ele.firstName+' '+ele.middleName+' '+ele.lastName;
  //       return ele;
  //     });
  //   });
  // } 

  getLanguages() {
    this.apiService.getLanguages().pipe(takeUntil(this.destroy$)).subscribe((response) => {
      if(response && response.length>0){
        this.languagesList = response.filter(lang=>{if(lang.name!=='English'){return lang;}});
        if(this.subTaskDetails && this.subTaskDetails.interpreterLanguage){
          const savedLanguage = this.languagesList.find((lang)=> lang.name === this.subTaskDetails.interpreterLanguage );
          if(savedLanguage){
            this.form.patchValue({interpreterLangId: this.subTaskDetails.interpreterLangId });
            this.interpreterDetailsForm.patchValue({interpreterLanguageId: this.subTaskDetails.interpreterLangId });
            this.onLanguageChange({value:savedLanguage.id });
          }
        }
      }
    });
  }

  includeInterpreter(event: any) {
    //this.isIncludeInterpreter = event.checked;
    if (this.isIncludeInterpreter) {
      this.form.controls['isInterpreterReqd'].setValue('Yes');

      this.form.controls['interpreterLangId'].setValue('');
      this.form.controls['interpreterLangId'].setValidators([Validators.required]);
      this.form.controls['interpreterLangId'].updateValueAndValidity();

      this.form.controls['interpreterId'].setValue('');
      this.form.controls['interpreterId'].setValidators([Validators.required]);
      this.form.controls['interpreterId'].updateValueAndValidity();

      this.form.controls['interpreterLanguageId'].setValue('');
      this.form.controls['interpreterLanguageId'].setValidators([Validators.required]);
      this.form.controls['interpreterLanguageId'].updateValueAndValidity();

      this.interpreterDetailsForm.controls['isInterpreterReqd'].setValue('Yes');
     this.interpreterDetailsForm.controls['interpreterLangId'].setValidators([Validators.required]);
      this.interpreterDetailsForm.controls['interpreterLangId'].updateValueAndValidity();
     this.interpreterDetailsForm.controls['interpreterId'].setValidators([Validators.required]);
      this.interpreterDetailsForm.controls['interpreterId'].updateValueAndValidity();
     this.interpreterDetailsForm.controls['interpreterLanguageId'].setValidators([Validators.required]);
      this.interpreterDetailsForm.controls['interpreterLanguageId'].updateValueAndValidity();

    } else {
      this.form.controls['isInterpreterReqd'].setValue('No');
      this.form.controls['interpreterLangId'].setValue('');
      this.form.controls['interpreterId'].setValue('');
      this.form.controls['interpreterLangId'].clearValidators();
      this.form.controls['interpreterLangId'].updateValueAndValidity();
      this.form.controls['interpreterId'].clearValidators();
      this.form.controls['interpreterId'].updateValueAndValidity();
      this.form.controls['interpreterLanguageId'].clearValidators();
      this.form.controls['interpreterLanguageId'].updateValueAndValidity();

      this.interpreterDetailsForm.controls['isInterpreterReqd'].setValue('No');
      this.interpreterDetailsForm.controls['interpreterLangId'].setValue('');
      this.interpreterDetailsForm.controls['interpreterId'].setValue('');
      this.interpreterDetailsForm.controls['interpreterLangId'].clearValidators();
      this.interpreterDetailsForm.controls['interpreterLangId'].updateValueAndValidity();
      this.interpreterDetailsForm.controls['interpreterId'].clearValidators();
      this.interpreterDetailsForm.controls['interpreterId'].updateValueAndValidity();
      this.interpreterDetailsForm.controls['interpreterLanguageId'].clearValidators();
      this.interpreterDetailsForm.controls['interpreterLanguageId'].updateValueAndValidity();
    }
  } 

  onLanguageChange(event) {  
    this.getInterpreterList(event.value);  
    this.form.controls['interpreterLangId'].setValue(event.value);
    this.interpreterDetailsForm.controls['interpreterLangId'].setValue(event.value);
    this.languagesList.forEach(eve=>{
      if(eve.id==event.value){
        this.selectedlanguage=eve.name;
      }
    });
  }

  getInterpreterList(langId){  
    let prepareAttorneyId = sessionStorage.getItem("setPreparerAttorneyId");
    let employeeId =  prepareAttorneyId && prepareAttorneyId !='undefined' ? prepareAttorneyId : (this.form.value.preparerAttorneyId ? this.form.value.preparerAttorneyId : (this.subTaskDetails && this.subTaskDetails.preparerAttorneyId ? this.subTaskDetails.preparerAttorneyId : null)); 
     if(!employeeId || employeeId == 'undefined'){
      this.toast.warning('Attorney Firm and Preparer Name not selected.', 'Warning');
      return;
     }
    this.interpreterList=[];
    this.form.controls['interpreterLanguageId'].setValue('');
    this.interpreterDetailsForm.controls['interpreterLanguageId'].setValue('');
    this.form.controls['interpreterId'].setValue('');
    this.interpreterDetailsForm.controls['interpreterId'].setValue('');

    this.apiService.interpreterList(langId,employeeId).pipe(takeUntil(this.destroy$)).subscribe((response) => {
      this.interpreterList = response.map(ele=>{
        ele.name = ele.firstName+' '+ele.middleName+' '+ele.lastName;
        return ele;
      }); 
     if(this.interpreterList.length==0){
      this.toast.warning('Interpreter not found for selected Attorney Firm and Preparer Name.', 'Warning');
     }else{
      if(this.subTaskDetails && this.subTaskDetails.interpreterName){
        const savedInterprater = this.interpreterList.find((intprtr)=> intprtr.name === this.subTaskDetails.interpreterName);
        if(savedInterprater){
          this.form.patchValue({interpreterId: savedInterprater.id });
          this.interpreterDetailsForm.patchValue({interpreterId: savedInterprater.id  });
          this.onInterpreterChange({value: savedInterprater.id});
        }
      }
     } 
    });
  }


  onInterpreterChange(event) {     
    let interpreter = [];
    async function  getInterpreterLanguageId(arr, lang){ 
      let interpreterLanguageId =''; 
      arr.languages.forEach((element,i) => { 
        if (element == lang) {  
         interpreterLanguageId=arr.languagesIds[i];  
        } 
      });
      return interpreterLanguageId;  
    }

    this.interpreterList.forEach(async (ele) => {
      if (ele.id == event.value) {
        await interpreter.push(event.name); 
       let lang = await getInterpreterLanguageId(ele, this.selectedlanguage);
        this.interpreterDetailsForm.controls['interpreterId'].setValue(ele.id);
        this.form.controls['interpreterId'].setValue(ele.id); 
        this.interpreterDetailsForm.controls['interpreterLanguageId'].setValue(lang);
        this.form.controls['interpreterLanguageId'].setValue(lang); 
      }
    }); 
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
